const hook = {
    missing_events: 'Vous devez fournir au moins un événement.',
    send_test_payload_failed: "Échec de l'envoi de la charge utile de test : {{message}}",
    endpoint_responded_with_error: 'Le point de terminaison a répondu avec une erreur.',
};
export default Object.freeze(hook);
